import React from 'react'
import Toast from 'react-bootstrap/Toast'
import classNames from 'classnames'

import Portal from '../Portal'
import { ToastContainer } from './ToastContainer'
import { useToast } from './ToastProvider'
import { ToastBody } from 'react-bootstrap'
import { ToastHeader } from './ToastHeader'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

export default function AppToastContainer() {
  const { notifications, removeNotification } = useToast()
  const items = notifications.map((notification) => ({
    ...notification,
    nodeRef: React.createRef(null),
  }))

  return (
    <Portal wrapperId="app-toast">
      <ToastContainer position="bottom-start">
        <TransitionGroup className="toasts">
          {items.map((notification) => (
            <CSSTransition key={notification.id} nodeRef={notification.nodeRef} timeout={500} classNames="toast">
              <Toast
                onClose={() => removeNotification(notification.id)}
                show
                delay={notification.delay ? notification.delay : 60000}
                autohide
                className={classNames(
                  !notification.description && 'toast--single-line',
                  notification.size === 'sm' && 'toast--sm'
                )}
                ref={notification.nodeRef}
              >
                <ToastHeader variant={notification.variant} onClose={() => removeNotification(notification.id)}>
                  {notification.message}
                </ToastHeader>
                {notification.description && <ToastBody>{notification.description}</ToastBody>}
              </Toast>
            </CSSTransition>
          ))}
        </TransitionGroup>
      </ToastContainer>
    </Portal>
  )
}
